module.exports = __webpack_public_path__ + "static/media/hero_bg.6c27d0da.png";